var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'inline-block font-semibold rounded',
    _vm.statusClass,
    _vm.large ? 'px-4 py-2' : 'text-sm p-2' ]},[_vm._v("\n  "+_vm._s(_vm.status)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }